<template>
    <div class="card">
        <header class="card-header">
            <router-link to="/users/" class="card-header-title">
                Assigned Clients
            </router-link>
            <router-link to="/users/" class="card-header-icon" aria-label="more options">
                  <span class="icon has-text-danger">
                    <i class="fas fa-users" aria-hidden="true"></i>
                  </span>
            </router-link>
        </header>
        <div class="card-content">
            <router-link to="/users/" class="total has-text-primary">{{ totalAssignedUsers }}</router-link>
        </div>
    </div>
</template>

<script>
    import apiUsers from '../../../api/apiUsers'
    export default {
        data() {
            return {
                totalAssignedUsers: 0
            }
        },
        mounted() {
            apiUsers
                .requestAllManagerAssignedClientsNumber()
                .then((response) => {
                    this.totalAssignedUsers = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>
    .card {
        height: 255px;
    }
    .card-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .total {
        font-size: 5rem;
        font-weight: 600;
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Manager/Users.vue